import dayjs from 'dayjs';

const storageKey = (dashboardId, userId) => `biDashboardFilter_${userId}_${dashboardId}`;

export const createDefaultDashboardFilter = () => ({
  businessPartner: null,
  responsible: null,
  year: '',
  halfYear: '',
  quarter: '',
  week: '',
  month: '',
  interval: {
    from: null,
    to: null,
  },
});

export const serializeDashboardFilter = (filter) => ({
  businessPartner: filter?.businessPartner ?? null,
  responsible: filter?.responsible ?? null,
  year: filter?.year ?? '',
  halfYear: filter?.halfYear ?? '',
  quarter: filter?.quarter ?? '',
  week: filter?.week ?? '',
  month: filter?.month ?? '',
  interval: {
    from: filter?.interval?.from ? dayjs(filter.interval.from).format('YYYY-MM-DD') : null,
    to: filter?.interval?.to ? dayjs(filter.interval.to).format('YYYY-MM-DD') : null,
  },
});

export const hydrateDashboardFilter = (filter) => {
  const serializedFilter = serializeDashboardFilter(filter);

  return {
    ...serializedFilter,
    interval: {
      from: serializedFilter.interval.from ? dayjs(serializedFilter.interval.from) : null,
      to: serializedFilter.interval.to ? dayjs(serializedFilter.interval.to) : null,
    },
  };
};

export const loadDashboardFilter = (dashboardId, userId) => {
  if (!dashboardId || !userId || typeof window === 'undefined') return createDefaultDashboardFilter();

  try {
    const savedFilter = JSON.parse(localStorage.getItem(storageKey(dashboardId, userId)));
    return savedFilter ? hydrateDashboardFilter(savedFilter) : createDefaultDashboardFilter();
  } catch {
    return createDefaultDashboardFilter();
  }
};

export const saveDashboardFilter = (dashboardId, userId, filter) => {
  if (!dashboardId || !userId || typeof window === 'undefined') return;
  localStorage.setItem(storageKey(dashboardId, userId), JSON.stringify(serializeDashboardFilter(filter)));
};

export const restrictDashboardFilter = (filter, dashboard) => ({
  businessPartner: dashboard?.bpFilter ? filter?.businessPartner ?? null : null,
  responsible: dashboard?.responsibleFilter ? filter?.responsible ?? null : null,
  year: dashboard?.yearFilter ? filter?.year ?? '' : '',
  halfYear: dashboard?.halfYearFilter ? filter?.halfYear ?? '' : '',
  quarter: dashboard?.quarterFilter ? filter?.quarter ?? '' : '',
  week: dashboard?.weekFilter ? filter?.week ?? '' : '',
  month: dashboard?.monthFilter ? filter?.month ?? '' : '',
  interval: {
    from: dashboard?.intervalFilter ? filter?.interval?.from ?? null : null,
    to: dashboard?.intervalFilter ? filter?.interval?.to ?? null : null,
  },
});
